// LMBCRBEForm.js
import React, { useState, useMemo, useEffect } from "react";
import { useEtatGlobal } from "../../../EtatGlobal.js";
import { Building2, ChevronDown, Check } from "lucide-react";
import { Input } from "../../../../components/ui/input.js";
import CabinetSelect from "../../components/CabinetSelect";

// LM Bon de commande — Registre des Bénéficiaires Effectifs (RBE). Le
// document ne comporte que 3 variables propres au client (nom_client,
// adresse, mail — l'adresse mail à laquelle la LM est envoyée) en plus de
// lieu_collab/date_jour (déjà globaux) et du pied de page cabinet standard
// (CABINETS_LM) : pas de contact référent nommé (civilité/nom/prénom/
// téléphone), ni de SIREN (retiré du modèle), contrairement aux autres LM.
//
// Le champ "email" ci-dessous EST le {mail} du template (mappé dans
// generateDocument, SignModif.js) — pas un champ dédié séparé — pour qu'il se
// pré-remplisse automatiquement avec l'email du client/prospect sélectionné
// via ClientSearch.js, comme pour toutes les autres LM.
function LMBCRBEForm({ handleInputChange, setDetailsMission, setDetailsHonoraire }) {
  const [isOpen, setIsOpen] = useState(true);

  const { formData } = useEtatGlobal();

  const isValid = useMemo(() => {
    // "adresse" n'est pas obligatoire — nullable, laissée vide dans le
    // document généré si non renseignée.
    const requiredFields = ["nom_client", "lieu_collab", "email"];

    return requiredFields.every((field) => {
      const value = formData[field];
      return (
        value !== " " && value !== null && value !== undefined && value !== ""
      );
    });
  }, [formData]);

  // Une seule section ici (pas d'honoraires/mission distincts) : les deux
  // indicateurs de complétion de l'en-tête reflètent la même validation.
  useEffect(() => {
    setDetailsMission(isValid);
    setDetailsHonoraire(isValid);
  }, [isValid, setDetailsMission, setDetailsHonoraire]);

  return (
    <div className="Container">
      <div
        className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
          onClick={() => setIsOpen(!isOpen)}
        >
          <div
            style={{
              display: "flex",
              gap: "25px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                isValid
                  ? "bg-emerald-100 text-emerald-700"
                  : "bg-slate-100 text-slate-600"
              }`}
            >
              {isValid ? (
                <Check className="w-5 h-5" />
              ) : (
                <Building2 className="w-5 h-5" />
              )}
            </div>

            <h3 className="font-semibold text-slate-800" style={{ margin: 0 }}>
              1. Votre entité
            </h3>
          </div>
          <ChevronDown
            className={`w-5 h-5 text-slate-400 transition-transform ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </div>
        {isOpen && (
          <div className="p-6 pt-0 space-y-4">
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="text-slate-600 mb-1 block text-xs">
                    Nom du client
                  </label>
                  <Input
                    type="text"
                    name="nom_client"
                    value={formData.nom_client}
                    onChange={handleInputChange}
                    required
                    className="bg-white border-slate-200 h-9 text-sm"
                  />
                </div>
                <CabinetSelect />
              </div>

              <div className="space-y-4">
                <div>
                  <label className="text-slate-600 mb-1 block text-xs">
                    Adresse
                  </label>
                  <Input
                    type="text"
                    name="adresse"
                    value={formData.adresse}
                    onChange={handleInputChange}
                    className="bg-white border-slate-200 h-9 text-sm"
                  />
                </div>
                <div>
                  <label className="text-slate-600 mb-1 block text-xs">
                    Email du client
                  </label>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="bg-white border-slate-200 h-9 text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LMBCRBEForm;
